import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_arrow_left.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-up-red.svg'
import _imports_2 from '@/app/ui/assets/svg/chevron-down-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-9136ec12")

_pushScopeId("data-v-9136ec12")
const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px h-screen" }
const _hoisted_2 = {
  class: "px-8 py-3 flex flex-col lg:flex-row justify-between lg:items-center gap-2 lg:gap-0",
  style: {"border-bottom":"1px solid rgba(224, 224, 224, 1)"}
}
const _hoisted_3 = { class: "font-semibold text-20px whitespace-nowrap text-black-lp-100 capitalize h-auto w-full flex items-center justify-between gap-x-3" }
const _hoisted_4 = { class: "flex items-center gap-x-3" }
const _hoisted_5 = { class: "flex items-center gap-x-3" }
const _hoisted_6 = {
  key: 0,
  class: "h-full justify-center bg-gray-lp-1000"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-gray-lp-1000 pt-2 pb-16 px-5 h-full w-full gap-x-2 overflow-scroll flex flex-col gap-y-2"
}
const _hoisted_8 = { class: "flex flex-row justify-between px-6 items-center border-b border-gray-lp-1400" }
const _hoisted_9 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_10 = { class: "text-base text-black-lp-100 font-semibold" }
const _hoisted_11 = { class: "flex flex-row items-center gap-x-4" }
const _hoisted_12 = { class: "text-base text-black-lp-100 font-bold" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "px-6 py-2 gap-x-4" }
const _hoisted_15 = {
  key: 1,
  class: "flex flex-col gap-y-1"
}
const _hoisted_16 = { class: "font-medium text-base text-black-lp-100" }
const _hoisted_17 = { class: "flex flex-col border border-gray-lp-1400 rounded-lg gap-y-1 px-4 py-2 w-full" }
const _hoisted_18 = { class: "flex flex-row items-center gap-x-1" }
const _hoisted_19 = { class: "font-semibold text-base text-black-lp-100 overflow-ellipsis line-clamp-1" }
const _hoisted_20 = { class: "font-medium text-base text-black-lp-100 overflow-ellipsis line-clamp-1" }
const _hoisted_21 = { class: "text-sm text-black-lp-100 overflow-ellipsis break-words line-clamp-2" }
const _hoisted_22 = { class: "px-6" }
const _hoisted_23 = { class: "flex flex-row items-center justify-between p-4 bg-gray-lp-100" }
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "flex flex-row items-center" }
const _hoisted_26 = { class: "font-semibold text-base text-black-lp-100 overflow-ellipsis line-clamp-1 mr-1" }
const _hoisted_27 = { class: "font-medium text-base text-black-lp-100 overflow-ellipsis line-clamp-1" }
const _hoisted_28 = { class: "text-sm text-black-lp-100 overflow-ellipsis break-words line-clamp-2" }
const _hoisted_29 = { class: "flex flex-row pl-6 pr-1 gap-x-2 items-center justify-end font-semibold" }
const _hoisted_30 = {
  key: 1,
  class: "flex flex-col justify-end mr-2"
}
const _hoisted_31 = { class: "text-sm text-gray-lp-300 text-right" }
const _hoisted_32 = { class: "text-base text-right font-bold" }
const _hoisted_33 = { class: "text-green-lp-400" }
const _hoisted_34 = { class: "text-gray-lp-800" }
const _hoisted_35 = {
  key: 3,
  class: "flex flex-col border-l px-2 border-gray-lp-1400 justify-end"
}
const _hoisted_36 = { class: "text-sm text-gray-lp-300 text-right" }
const _hoisted_37 = { class: "text-base text-red-lp-100 text-right" }
const _hoisted_38 = {
  key: 0,
  src: _imports_1,
  class: `w-6`,
  alt: "up"
}
const _hoisted_39 = {
  key: 1,
  src: _imports_2,
  class: `w-6`,
  alt: "down"
}
const _hoisted_40 = {
  key: 0,
  class: "overflow-y-auto popup-dimension flex-grow px-4 py-1 relative"
}
const _hoisted_41 = { class: "table-fixed w-full" }
const _hoisted_42 = /*#__PURE__*/_createVNode("thead", { class: "sticky top-0 z-10" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "w-90 text-left font-bold text-black-lp-300 py-1 pr-3 whitespace-nowrap" }, " Produk "),
    /*#__PURE__*/_createVNode("th", { class: "w-40 border-l border-gray-lp-200 text-left font-bold text-black-lp-300 py-1 px-3 whitespace-nowrap" }, " Total item "),
    /*#__PURE__*/_createVNode("th", { class: "w-40 border-l border-gray-lp-200 text-left font-bold text-black-lp-300 py-1 px-3 whitespace-nowrap" }, " Harga satuan "),
    /*#__PURE__*/_createVNode("th", { class: "w-40 border-l border-gray-lp-200 text-left font-bold text-black-lp-300 py-1 px-3 whitespace-nowrap" }, " Total yang dibeli "),
    /*#__PURE__*/_createVNode("th", { class: "w-40 border-l border-gray-lp-200 text-right font-bold text-black-lp-300 py-1 pl-3 whitespace-nowrap" }, " Subtotal ")
  ])
], -1)
const _hoisted_43 = { class: "text-left py-3" }
const _hoisted_44 = { class: "flex items-center gap-1" }
const _hoisted_45 = { class: "flex flex-col" }
const _hoisted_46 = { class: 
                              `text-sm font-semibold text-black-lp-100 overflow-ellipsis line-clamp-1`
                             }
const _hoisted_47 = { class: "text-left px-3 py-3 text-16px" }
const _hoisted_48 = { class: "text-left px-3 py-3 text-16px" }
const _hoisted_49 = { class: "text-left px-3 py-3 text-16px" }
const _hoisted_50 = { class: "text-right py-3 text-16px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Chips = _resolveComponent("Chips")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_HistoryOrder = _resolveComponent("HistoryOrder")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ModalSuccessProcessOrder = _resolveComponent("ModalSuccessProcessOrder")!
  const _component_ModalProcessKulioner = _resolveComponent("ModalProcessKulioner")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("img", {
              src: _imports_0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
              class: "w-6 mr-1 cursor-pointer",
              alt: "back"
            }),
            _createVNode("span", null, _toDisplayString(_ctx.detailData.orderId), 1),
            _createVNode(_component_Chips, {
              label: _ctx.mapStatusLabel(_ctx.detailData.status),
              color: _ctx.getStatusOrder(_ctx.detailData.status).color,
              textColor: _ctx.getStatusOrder(_ctx.detailData.status).textColor,
              textSize: 14,
              weight: "medium",
              rounded: ""
            }, null, 8, ["label", "color", "textColor"]),
            _createVNode("div", {
              class: "flex flex-row px-2 py-0.5 gap-1 rounded-2xl",
              style: { backgroundColor: _ctx.mapCycleTime(_ctx.detailData.cycleAt).background }
            }, [
              (_ctx.detailData.cycleAt)
                ? (_openBlock(), _createBlock(_component_Icons, {
                    key: 0,
                    name: "clock-v4",
                    style: [{"width":"18px","height":"18px"}, { color: _ctx.mapCycleTime(_ctx.detailData.cycleAt).color }]
                  }, null, 8, ["style"]))
                : _createCommentVNode("", true),
              _createVNode("p", {
                class: "font-medium text-sm",
                style: { color: _ctx.mapCycleTime(_ctx.detailData.cycleAt).color }
              }, _toDisplayString(_ctx.mapCycleTime(_ctx.detailData.cycleAt).label), 5)
            ], 4)
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_LpButton, {
              id: "button_download_order_detail_kulioner",
              title: _ctx.$t('Download data'),
              color: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
              textColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
              iconGroupHoverColor: "gray-lp-300",
              iconV2: "",
              iconLeft: "download-new",
              iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
              small: "",
              fontWeight: "semibold",
              outline: "",
              disabled: _ctx.isLoadingDownloadOrder,
              onClick: _ctx.onDownloadOrder
            }, null, 8, ["title", "color", "textColor", "iconColor", "disabled", "onClick"]),
            (_ctx.showPrintReceipt)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  id: "button_print_receipt_detail_kulioner",
                  title: _ctx.$t('Print PDF'),
                  color: "gray-lp-300",
                  textColor: "gray-lp-300",
                  iconGroupHoverColor: "gray-lp-300",
                  iconColor: _ctx.isLoadingDownloadOrder ? 'gray-lp-600' : 'gray-lp-300',
                  iconLeft: "printer-black",
                  small: "",
                  fontWeight: "semibold",
                  outline: "",
                  disabled: _ctx.isLoadingPrintReceipt,
                  onClick: _cache[2] || (_cache[2] = () => _ctx.onPrintReceipt(_ctx.detailData.orderSttNo))
                }, null, 8, ["title", "iconColor", "disabled"]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_LpButton, {
              id: "button_update_order_detail_kulioner",
              title: _ctx.buttonTitleUpdate,
              textColor: "red-lp-100",
              outline: "",
              fontWeight: "semibold",
              isWidthFull: true,
              disabled: _ctx.isLoadingSubmitBtn || _ctx.disableUpdateOrderByCustomer,
              onClick: _ctx.updateOrder
            }, null, 8, ["title", "disabled", "onClick"]), [
              [_vShow, _ctx.buttonTitleUpdate]
            ]),
            _withDirectives(_createVNode(_component_LpButton, {
              id: _ctx.buttonId,
              title: _ctx.buttonTitle,
              textColor: "white",
              fontWeight: "semibold",
              isWidthFull: true,
              disabled: _ctx.isLoadingSubmitBtn || _ctx.disableProcessOrderByCustomer,
              onClick: _ctx.onButtonClick
            }, null, 8, ["id", "title", "disabled", "onClick"]), [
              [_vShow, _ctx.buttonTitle]
            ])
          ])
        ])
      ]),
      (_ctx.isError)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_EmptyList, {
              "button-action": _ctx.buttonActionError,
              onAction: _ctx.getDetail,
              icon: _ctx.errorData.icon,
              customHeaderMessage: _ctx.errorData.header,
              customMessage: _ctx.errorData.message,
              customClassImage: "w-44"
            }, null, 8, ["button-action", "onAction", "icon", "customHeaderMessage", "customMessage"])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_HistoryOrder, {
              detail: _ctx.detailData,
              loading: _ctx.isLoading
            }, null, 8, ["detail", "loading"]),
            _createVNode(_component_Card, {
              rounded: "2xl",
              class: "flex flex-col py-4"
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_8, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_Skeleton, {
                        key: 0,
                        height: "2.75rem",
                        width: "8.5rem"
                      }))
                    : (_openBlock(), _createBlock("div", _hoisted_9, [
                        _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("claim.detail.noSTTGenesis")), 1),
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.detailData.orderSttNo || "-"), 1),
                          (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_Skeleton, {
                                key: 0,
                                height: "1.3rem",
                                width: "6.25rem"
                              }))
                            : (_openBlock(), _createBlock("div", _hoisted_13, [
                                _createVNode("img", {
                                  src: 
                    require(`@/app/ui/assets/svg/product-logo/${_ctx.detailData.productType.toLowerCase()}-active.svg`)
                  ,
                                  class: "w-100px h-12"
                                }, null, 8, ["src"])
                              ]))
                        ])
                      ]))
                ]),
                _createVNode("div", _hoisted_14, [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_Skeleton, {
                        key: 0,
                        height: "9.3rem",
                        width: "100%"
                      }))
                    : (_openBlock(), _createBlock("div", _hoisted_15, [
                        _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("claim.detail.recipientName")), 1),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.detailData.recipientName), 1),
                            _createVNode("div", _hoisted_20, " (" + _toDisplayString(_ctx.censorPhoneLastFour(_ctx.detailData.recipientPhoneNumber)) + ") ", 1)
                          ]),
                          _createVNode("div", _hoisted_21, _toDisplayString(_ctx.detailData.recipientAddress), 1)
                        ])
                      ]))
                ]),
                _createVNode("div", _hoisted_22, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.merchants, (merchant, mIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      key: mIndex,
                      class: "flex flex-col mt-2 border border-gray-lp-1400 rounded-lg"
                    }, [
                      _createVNode("div", _hoisted_23, [
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode("div", _hoisted_26, _toDisplayString(merchant.name), 1),
                            _createVNode("div", _hoisted_27, [
                              _createTextVNode(" (" + _toDisplayString(merchant.phoneNumber) + ") ", 1),
                              _createVNode("a", {
                                class: "text-red-lp-100 underline font-semibold text-[16px] cursor-pointer",
                                href: `https://www.google.com/maps?q=${merchant.latLon}`,
                                target: "_blank"
                              }, " Lihat lokasi ", 8, ["href"])
                            ])
                          ]),
                          _createVNode("div", _hoisted_28, _toDisplayString(merchant.address), 1)
                        ]),
                        _createVNode("div", _hoisted_29, [
                          (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_Skeleton, {
                                key: 0,
                                height: "2.6rem",
                                width: "6.5rem"
                              }))
                            : (_openBlock(), _createBlock("div", _hoisted_30, [
                                _createVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalItem")), 1),
                                _createVNode("span", _hoisted_32, [
                                  _createVNode("span", _hoisted_33, _toDisplayString(_ctx.getMerchantSummary(merchant).totalActualQuantity), 1),
                                  _createVNode("span", _hoisted_34, "/" + _toDisplayString(_ctx.getMerchantSummary(merchant).totalQuantity), 1)
                                ])
                              ])),
                          (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_component_Skeleton, {
                                key: 2,
                                height: "2.6rem",
                                width: "6.5rem"
                              }))
                            : (_openBlock(), _createBlock("div", _hoisted_35, [
                                _createVNode("div", _hoisted_36, _toDisplayString(_ctx.$t("kulioner.merchant.summary.totalTransaction")), 1),
                                _createVNode("div", _hoisted_37, _toDisplayString(_ctx.formatPriceRP(merchant.totalPrice)), 1)
                              ])),
                          _createVNode(_component_Badge, {
                            id: "merchant-badge",
                            value: _ctx.getBadgeStatus(merchant).label,
                            severity: _ctx.getBadgeStatus(merchant).severity
                          }, null, 8, ["value", "severity"]),
                          _createVNode("div", {
                            class: "cursor-pointer",
                            onClick: ($event: any) => (_ctx.setExpand(mIndex))
                          }, [
                            (_ctx.isExpandDetail(mIndex))
                              ? (_openBlock(), _createBlock("img", _hoisted_38))
                              : (_openBlock(), _createBlock("img", _hoisted_39))
                          ], 8, ["onClick"])
                        ])
                      ]),
                      (_ctx.isExpandDetail(mIndex))
                        ? (_openBlock(), _createBlock("div", _hoisted_40, [
                            _createVNode("table", _hoisted_41, [
                              _hoisted_42,
                              _createVNode("tbody", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products(mIndex), (product, pIndex) => {
                                  return (_openBlock(), _createBlock("tr", {
                                    key: pIndex,
                                    class: "border-t border-gray-lp-200"
                                  }, [
                                    _createVNode("td", _hoisted_43, [
                                      _createVNode("div", _hoisted_44, [
                                        _createVNode("img", {
                                          src: `${product.thumbnail}`,
                                          class: "w-10 h-10 mr-1 rounded-md",
                                          alt: "product"
                                        }, null, 8, ["src"]),
                                        _createVNode("div", _hoisted_45, [
                                          _createVNode("p", _hoisted_46, _toDisplayString(product.name), 1)
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", _hoisted_47, _toDisplayString(product.quantity), 1),
                                    _createVNode("td", _hoisted_48, _toDisplayString(_ctx.formatPriceRP(product.price)), 1),
                                    _createVNode("td", _hoisted_49, _toDisplayString(product.actualQuantity), 1),
                                    _createVNode("td", _hoisted_50, _toDisplayString(_ctx.formatPriceRP(product.totalPrice)), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]))
    ]),
    _createVNode(_component_ModalSuccessProcessOrder, {
      key: _ctx.successProcessResponse.sttId,
      modelValue: _ctx.isShowSuccessProcessModal,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isShowSuccessProcessModal = $event)),
      messageData: _ctx.successProcessResponse,
      productType: _ctx.detailData.productType,
      onClose: _ctx.getDetail,
      onOnPrintThermalPdf: _ctx.onPrintReceipt
    }, null, 8, ["modelValue", "messageData", "productType", "onClose", "onOnPrintThermalPdf"]),
    _createVNode(_component_ModalProcessKulioner, {
      id: "modal-confirm-accept-order",
      modelValue: _ctx.isShowModalProcessKulioner,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isShowModalProcessKulioner = $event)),
      data: [_ctx.detailData],
      onSuccess: _ctx.onSuccess,
      onFailed: _ctx.onFailed,
      onRefetch: _ctx.closeModalSuccess
    }, null, 8, ["modelValue", "data", "onSuccess", "onFailed", "onRefetch"])
  ], 64))
})